const radioChannels = [
  {
    name: "Techno",
    id: 18,
    color: [],
    img: "https://i.imgur.com/d9X259J.gif",
    link: "/genres/melodic-house&techno",
  },
  {
    name: "Electronic",
    id: 260,
    color: [],
    img: "https://i.imgur.com/d9X259J.gif",
    link: "/genres/electronic&downtempo",
  },
  {
    name: "Tropical House",
    id: 364,
    color: [],
    img: "https://i.imgur.com/d9X259J.gif",
    link: "/genres/tropical-house",
  },
  {
    name: "Tech House",
    id: 170,
    color: [],
    img: "https://i.imgur.com/d9X259J.gif",
    link: "/genres/tech-house",
  },
  {
    name: "Deep Tech",
    id: 132,
    color: [],
    img: "https://i.imgur.com/d9X259J.gif",
    link: "/genres/minimal&deep-tech",
  },
  {
    name: "Deep House",
    id: 173,
    color: [],
    img: "https://i.imgur.com/d9X259J.gif",
    link: "/genres/house&deep-house",
  },
];

export default radioChannels;
